export default "__VITE_ASSET__BToUlw3A__"